var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2464_60071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.999C24.8366 31.999 32 24.8356 32 15.999C32 7.16247 24.8366 -0.000976562 16 -0.000976562C7.16344 -0.000976562 0 7.16247 0 15.999C0 24.8356 7.16344 31.999 16 31.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5599 17.287V23.8835H21.7354V17.7291C21.7354 16.1838 21.1832 15.1285 19.7985 15.1285C18.7418 15.1285 18.114 15.839 17.8368 16.5269C17.7361 16.7728 17.7102 17.1142 17.7102 17.459V23.8832H13.8854C13.8854 23.8832 13.9368 13.4597 13.8854 12.3808H17.7104V14.0108C17.7027 14.0236 17.6919 14.0362 17.6851 14.0484H17.7104V14.0108C18.2187 13.2287 19.1251 12.1107 21.1573 12.1107C23.6734 12.1107 25.5599 13.7546 25.5599 17.287ZM9.88443 6.83618C8.57614 6.83618 7.72021 7.69496 7.72021 8.82328C7.72021 9.92763 8.55133 10.8112 9.83423 10.8112H9.85904C11.193 10.8112 12.0224 9.92763 12.0224 8.82328C11.997 7.69496 11.193 6.83618 9.88443 6.83618ZM7.94753 23.8835H11.7708V12.3808H7.94753V23.8835Z",
    fill: "#39455E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2464_60071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3c857ac815a9de23b8c25db7f4f159c0.svg";
export { ForwardRef as ReactComponent };